import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';

// A clinician's changes to a patient's assignments: assigning an instrument
// and withdrawing one the patient has not started. Each settles with what
// GraphQL answered or rejects with its sentence.
export function useAssignmentChanges() {
  const graphql = useGraphql();

  const assign = useCallback(function({ patientId, code, version, instructions }) {
    return graphql({
      document: `mutation Assign($patientId: ID!, $code: String!, $version: String!, $instructions: String) {
        assignQuestionnaire(patientId: $patientId, code: $code, version: $version, instructions: $instructions) { id }
      }`,
      variables: { patientId, code, version, instructions }
    });
  }, [ graphql ]);

  const withdraw = useCallback(function(id) {
    return graphql({ document: 'mutation Withdraw($id: ID!) { withdrawAssignment(id: $id) }', variables: { id } });
  }, [ graphql ]);

  return useMemo(function() {
    return { assign, withdraw };
  }, [ assign, withdraw ]);
}
